/* src/components/add-project-library-items-modal/add-project-library-items-modal.component.scss */
:host {
  display: block;
  height: var(--vwui-modal--max-height);
}
:host .items-nav {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: var(--vwui-size-component-nav);
  background: var(--vwui--color--neutral-4);
  z-index: var(--vwui--zindex--nav);
  transition: width 0.25s ease-in-out;
  will-change: width;
}
:host .items-nav__header {
  position: relative;
  display: flex;
  align-items: center;
  padding-left: 3rem;
  height: var(--vwui-size-component-header);
  border-bottom: var(--vwui--border--base) var(--vwui--color--neutral-3);
}
:host .items-nav__items {
  padding: var(--vwui--spacing--lg);
}
:host .items-nav__toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  top: 50%;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 100%;
  transform: translate(50%, -50%);
  border: var(--vwui--border--base) var(--vwui--color--border);
  outline: 0;
  cursor: pointer;
  color: var(--vwui--color--neutral-1);
  background: var(--vwui--color--light);
}
:host .items-nav__toggle__icon {
  --size: 14px;
  transition: transform 0.15s ease-in-out;
}
:host .items-header {
  display: block;
  position: fixed;
  right: var(--vwui-size-spacing-lg);
  left: var(--vwui-size-component-nav);
  top: 0;
  z-index: var(--vwui--zindex--nav);
  line-height: 4rem;
  background:
    linear-gradient(
      180deg,
      rgb(255, 255, 255) 60%,
      rgba(255, 255, 255, 0) 100%);
  padding-left: var(--vwui-size-spacing-lg);
  font-weight: var(--vwui--font--semibold);
  font-size: 1.1rem;
}
:host .items-body {
  padding: calc(4rem - var(--vwui-size-spacing-base)) 0 6rem var(--vwui-size-component-nav);
}
:host .items-grid {
  display: grid;
  justify-items: stretch;
  grid-template-columns: repeat(auto-fit, calc(33.33333333% - 0.8rem));
  grid-gap: 1.2rem;
}
:host .items-footer {
  display: block;
  position: fixed;
  right: 0;
  left: var(--vwui-size-component-nav);
  bottom: 0;
  height: 5.5rem;
  padding: 1rem var(--vwui-size-spacing-lg);
  z-index: var(--vwui--zindex--nav);
  background: #fff;
  border-top: 1px solid var(--vwui-table--border-color, var(--vwui--color--border-light));
  box-sizing: border-box;
}
:host .items-footer__buttons {
  float: right;
  margin-top: 0.2rem;
}
:host .items-footer .deselect {
  color: var(--vwui-color-primary);
  cursor: pointer;
}
/*# sourceMappingURL=add-project-library-items-modal.component-ZPGDZVOR.css.map */
